import React from "react"
import { Helmet } from "react-helmet"
import { phoneNumber } from "../../config"

const MaintenanceError = () => (
  <>
    <img
      style={{ margin: 5 }}
      src="/coastline-logo.png"
      alt="Coastline Header"
    />
    <div className="container" style={{ textAlign: "center" }}>
      <Helmet>
        <title>Under Maintenance</title>
      </Helmet>
      <h1 style={{ fontSize: 50 }}>Under Maintenance</h1>
      <p style={{ fontSize: 25 }}>
        We apologize for the inconvenience, but our site is currently under
        maintenance.
      </p>
      <div style={{ textAlign: "center" }}>
        <img
          src="https://res.cloudinary.com/coastline-academy/image/upload/c_scale,q_auto,w_400/v1587161099/misc-images/404-towing_ffvyn0.png"
          alt="Coastline Error"
        />
      </div>
      <p style={{ fontSize: 25 }}>
        These updates should be completed shortly, so please check back soon to
        continue your journey with us!
      </p>
      <br />
      <p style={{ fontSize: 15 }}>
        Need help urgently? Give us a call at {phoneNumber}
      </p>
    </div>
  </>
)

export default MaintenanceError
